import React, { useContext } from "react";
import { SubscriptionDetailContext } from "../../../context/SubscriptionDetailContext";
import * as styles from "./styles.module.scss";
import { messages } from "../messages";
import { FormattedMessage } from "react-intl";
import { Title } from "@yoast/ui-library";

/**
 * A list of included courses in the subscription.
 * @returns {Element} The included courses.
 */
export const IncludedCourses = () => {
	const { subscription, request: { isFirstLoad } } = useContext( SubscriptionDetailContext );
	if ( isFirstLoad || subscription.included.inSelf.courses.length === 0 ) {
		return <></>;
	}

	return <section className={ styles.includedCourses }>
		<Title as={ "p" } size={ "5" }>
			<FormattedMessage { ...messages.coursesTitle } />
		</Title>
		<ul className={ styles.courseList }>
			{ subscription.included.inSelf.courses.map( course => {
				return <li key={ course.name }>
					<span>{ course.name }</span>
				</li>;
			} ) }
		</ul>
	</section>;
};
